/*
 * @author: xd
 * @Date: 2021-12-14 18:50:08
 * @LastEditors: xd
 * @LastEditTime: 2022-06-25 14:10:23
 * @Description: 功能
 */
import { Secret } from "../modules/Secret/secret";
export class BaseClass {
  constructor() {}

  // getPid(): string {
  //   let ss = new Secret();
  //   let item = localStorage.getItem("pid");
  //   if (item == null) {
  //     return "";
  //   } else {
  //     return ss.Decrypt1(item);
  //   }
  // }
  // getAppid(): string {
  //   let ss = new Secret();
  //   let item = localStorage.getItem("aid");
  //   if (item == null) {
  //     return "";
  //   } else {
  //     return ss.Decrypt1(item);
  //   }
  // }

  // getUrl(): string {
  //   let ss = new Secret();
  //   let item = localStorage.getItem("url");
  //   if (item == null) {
  //     return "";
  //   } else {
  //     return ss.Decrypt1(item);
  //   }
  // }
}
